export default __webpack_public_path__ + "static/media/loading_training_video.20ad3cb2.gif";